import { render } from "./Error.vue?vue&type=template&id=aac71836&ts=true&lang=pug"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__